import {CreatedAtAndUpdatedBy} from '@dms/api/shared';

export type BaseAuthorizationProfile = {
  id: string;
  tenantId: string;
  branchId: string;
  authorizationId: string;
  name: string;
  isActive: boolean;
  isDefault: boolean;
  companyId: string;
  companyAddressId: string;
  dealerNo?: string;
  validFrom?: string;
  validUntil?: string;
};

export type GetAuthorizationProfilesRequest = {
  'x-tenant': string;
  branchId?: string;
};
export type GetAuthorizationProfilesResponse = BaseAuthorizationProfile;

export type GetAuthorizationProfileRequest = {
  authorizationProfileId: string;
  'x-tenant': string;
};

export type GetAuthorizationProfileResponse = BaseAuthorizationProfile & CreatedAtAndUpdatedBy;

export type GetAuthorizationProfileHasIntegrationRequest = {
  authorizationProfileId: string;
  'accept-language'?: string | null;
  'x-tenant'?: string | null;
  'x-workspace'?: string | null;
};

export type GetAuthorizationProfileHasIntegrationResponse =
  | /** status 200 Standard response */ ({
      integration?: GetAuthorizationProfileHasIntegrationResponseIntegration[];
    } | null)
  | /** status 204 Standard response */ undefined;

export type GetAuthorizationProfileHasIntegrationResponseIntegration = {
  id: string;
  name: string;
  code: string;
  description?: string | null;
} | null;

export type GetAuthorizationProfilesByIntegrationIdRequest = {
  integrationId: string;
  'x-tenant': string;
};

export type GetAuthorizationProfilesByIntegrationIdResponse = [
  {authorizationProfileId: string; name: string},
];
export type AdmPostAuthorizationProfileHasIntegrationAdvancedSearchApiApiResponse =
  | /** status 200 Standard response */ ({
      authorizationProfile?: {
        id: string;
        tenantId: string;
        branchId: string;
        authorizationId: string;
        name: string;
        dealerNo?: string | null;
        isDefault: boolean;
        isActive: boolean;
        companyId?: string | null;
        companyAddressId?: string | null;
        createdAt?: string | null;
        createdBy?: string | null;
        updatedAt?: string | null;
        updatedBy?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      integration?: AdmPostAuthorizationProfileHasIntegrationAdvancedSearchApiApiResponseIntegration[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type AdmPostAuthorizationProfileHasIntegrationAdvancedSearchApiApiResponseIntegration = {
  id: string;
  name: string;
  code: string;
  description?: string | null;
} | null;
export type AdmPostAuthorizationProfileHasIntegrationAdvancedSearchApiApiArg = {
  'x-branch'?: string | null;
  'x-country'?: string | null;
  'x-currency'?: string | null;
  'x-tenant'?: string;
  'x-workspace'?: string;
  body: AdmPostAuthorizationProfileHasIntegrationAdvancedSearchApiApiArgBody;
};
export type AdmPostAuthorizationProfileHasIntegrationAdvancedSearchApiApiArgBody = {
  vehicleType: string | null;
  vehicleMake: string;
  vehicleModelFamilyGroup: string | null;
  vehicleModelFamily: string | null;
} | null;
